import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-quote",
  "use": "various-quote-usage",
  "viewBox": "0 0 30 35",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 35\" id=\"various-quote\"><path class=\"st0\" d=\"M0 14h11.8L2.2 33.3c-.2.5 0 1.1.5 1.3.5.2 1.1 0 1.3-.5L14 14V0H0v14zM16 0v14h11.8l-9.6 19.3c-.2.5 0 1.1.5 1.3.5.2 1.1 0 1.3-.5L30 14V0H16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol